import creativeWorks from "./creativeWorks";
import historic from "./historic";
import prehistoric from "./prehistoric";

export default [
  {
    id: "historic",
    label: "Historic Timeline",
    icon: "historical",
    template: historic,
    category: "historic",
    creator: "Timeline.App",
    description: "A template for history projects"
  },
  {
    id: "creativeWorks",
    label: "Creative Works",
    icon: "art",
    template: creativeWorks,
    category: "historic",
    creator: "Timeline.App",
    description: "A template for history projects"
  },
  {
    id: "prehistoric",
    label: "Prehistoric Timeline",
    icon: "fossil",
    template: prehistoric,
    category: "historic",
    creator: "Timeline.App",
    description: "A template for history projects"
  }
];
